import { inject, observer } from "mobx-react";
import { Avatar } from "primereact/avatar";
import ButtonUI from "@UI/ButtonUI";
import CardUI from "@UI/CardUI";
import InputUI from "@UI/InputUI";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import logo from "./img/logo.svg";

import "./style.scss";

const Auth = inject("mainStore")(
    observer(({ mainStore }) => {
        const navigation = useNavigate();
        const [fields, setFields] = useState({ email: "", password: "" });
        const [successLogin, setSuccessLogin] = useState(null);

        const handleChange = (e, key) => {
            setFields({ ...fields, [key]: e.target.value });
        };

        const disabledBtn = fields.email.length < 2 || fields.password.length < 4;

        const handleClickEnter = async () => {
            let result = await mainStore.getByUrl("admin/authorization", fields);

            if (result.success) {
                localStorage.setItem("_cms_token_v1", result.token);
                mainStore.setMainStore("toast", { severity: "success", summary: "Вы авторизовались", detail: "Добро пожаловать" });
                setSuccessLogin({ name: result.data.firstName, avatar: result.data.avatar });
                setTimeout(() => {
                    mainStore.setMainStore("auth", result.data);
                    navigation("/", { replace: true });
                }, 2000);
            }
        };

        return (
            <div className="auth">
                {successLogin ? (
                    <CardUI className="auth__success">
                        <Avatar image={successLogin.avatar} size="xlarge" shape="circle" />
                        <h3 className="p-card-title">{`Привет, ${successLogin.name}!`}</h3>
                    </CardUI>
                ) : (
                    <CardUI className="auth__block">
                        <img src={logo} className="auth__block-logo" />
                        <span className="auth__block-title">Сontent management</span>
                        <div className="auth__inputs">
                            <InputUI id="email" value={fields.email} onChange={(e) => handleChange(e, "email")} placeholder="Логин" />
                            <InputUI id="pass" type="password" value={fields.password} onChange={(e) => handleChange(e, "password")} placeholder="Пароль" toggleMask feedback={false} />
                        </div>

                        <ButtonUI id="authEnter" label="Войти" iconPos="right" onClick={handleClickEnter} disabled={disabledBtn} />
                    </CardUI>
                )}
            </div>
        );
    }),
);

export default Auth;
